export default __webpack_public_path__ + "static/media/trending-header.8730087f.png";